<template>
  <main-layout :selectedMenu="'myHome'">
    <section class="people_center">
      <div
        class="header"
        :style="
          userInfo.thumb
            | personBgImageUrl(
              'https://image.manamana.net/assets/pc/cn/person/v2/profile_default_bg.png'
            )
        "
      >
        <show-image
          v-if="showCrop"
          ref="showImage"
          :config="showConfig"
          @cancel="cancel"
          @submit="changeThumb"
        />
        <el-tooltip
          class="bg-notice"
          v-if="(userId == peopleMessage.userId) && !showCrop"
          effect="dark"
          placement="bottom-end"
        >
          <div slot="content">{{ $t("global.图片尺寸不小于1440*250px") }}</div>
          <el-button
            class="changeBg"
            v-if="(userId == peopleMessage.userId) && !showCrop"
            @click="uploadBg"
            >{{ $t("global.更换背景图") }}</el-button
          >
        </el-tooltip>
        <input
          type="file"
          ref="cropUpImage"
          accept="image/*"
          class="up-input-crop"
          @change="changeUrl"
        />
      </div>
      <div class="container">
        <div class="left">
          <div
            class="user_info"
            :class="{ userType2: userInfo.userType === 2 && userInfo.isCertification === 1 }"
          >
            <img
              class="user_avatar"
              :src="
                userInfo.avatar
                  | imageUrl('/static/profile_img_default.png', 280, 280)
              "
              alt
            />
            <span class="nickname">{{ userInfo.nickname }}</span>
            <span class="companyName" v-if="userInfo.userType === 2 && userInfo.isCertification === 1">{{
              userInfo.companyName
            }}</span>
            <div class="focus-warp">
              <button
                :key="1"
                class="member-focus following"
                data-data="1"
                v-if="userInfo.isFollow == 1"
                @mouseenter="toggleTitle1"
                @mouseleave="toggleTitle2"
                @click="followUser(userInfo)"
              >
                {{ $t("global.已关注") }}
              </button>
              <button
                :key="2"
                class="member-focus add-follow"
                data-data="2"
                v-else
                @click="followUser(userInfo)"
              >
                {{ $t("global.关注") }}
              </button>
              <el-tooltip class="bg-notice" effect="light" placement="bottom">
                <span
                  slot="content"
                  class="people-center-share-wrap"
                  @click="shareCkeck"
                  >{{ $t("global.分享") }}</span
                >
                <img
                  class="share"
                  src="/static/v2/peopleCenter/profile_more_btn.png"
                  alt
                />
              </el-tooltip>
            </div>
            <div
              class="liveNow"
              v-if="liveData != null && liveData.liveStatus == 1"
              @click="gotoLiveDetail(liveData.id)"
            >
              <p class="topLive">
                <img src="/static/icon_app_live_on_red.gif" alt />
                {{ $t("live.TA正在直播") }}：
              </p>
              <p class="text">
                {{ liveData.title }}
                <img
                  class="rightIcon"
                  src="/static/icon_web_profile_live_arrow@2x.png"
                  alt
                />
              </p>
            </div>
            <div
              class="liveNotice"
              v-if="liveData != null && liveData.liveStatus == 2"
              @click="gotoLiveDetail(liveData.id)"
            >
              <p class="topLive">
                <img src="/static/icon_web_live_today_red@2x.png" alt />
                {{ $t("live.直播预告") }}：
              </p>
              <p class="text">
                <span>{{ formatDate(liveData.liveStartTime, 1) }}</span>
                {{ liveData.title }}
                <img
                  class="rightIcon"
                  src="/static/icon_web_profile_live_arrow@2x.png"
                  alt
                />
              </p>
            </div>
            <p class="signature" v-if="userInfo.signature">
              {{ userInfo.signature }}
            </p>
            <div class="area-warp" :class="{ areaWarpEn: language !== 'zh' }">
              <img v-if="userInfo.area" src="/static/v2/location_icon.png" />
              <span class="area" v-if="userInfo.area">{{ userInfo.area }}</span>
              <div class="follow_fans">
                <span @click="showFollow">
                  {{ $t("user.关注") }}
                  <b>{{ userInfo.followCount }}</b>
                </span>
                <span @click="showFans">
                  {{ $t("global.粉丝") }}
                  <b>{{ userInfo.fansCount }}</b>
                </span>
              </div>
            </div>
            <div
              class="introduce"
              v-if="userInfo.enIntroduce || userInfo.introduce"
            >
              <p :class="{ checking: isChecking }">
                {{ $t("global.简介") }}：
                <span
                  class="intro"
                  v-if="language === 'zh'"
                  v-html="userInfo.introduce.replace(/&nbsp;/g, ' ')"
                ></span>
                <span
                  v-else
                  class="intro"
                  v-html="
                    userInfo.enIntroduce.replace(/&nbsp;/g, ' ') ||
                    userInfo.introduce.replace(/&nbsp;/g, ' ')
                  "
                ></span>
              </p>
              <router-link class="showdown" to="introduce" v-if="isChecking">{{
                $t("global.更多")
              }}</router-link>
            </div>
            <div
              class="field"
              v-if="userInfo.field && userInfo.field.length > 0"
            >
              <span v-for="item in userInfo.field" :key="item">{{ item }}</span>
            </div>
          </div>
          <div class="video_subject" v-if="subjectList.length">
            <h4>{{ $t("global.作品收录于") }}</h4>
            <ul>
              <li v-for="item in subjectList" :key="item.id">
                <router-link :to="`/subjectDetail/${item.id}/home`">
                  <img
                    :src="item.thumb | imageUrl('', 130, 130)"
                    alt
                    class="subject-left"
                  />
                  <div class="subject-right">
                    <h5 class="title">{{ item.title }}</h5>
                    <span>{{
                      $t("global.x件作品被收录", {
                        count: item.userVideoCount || 0,
                      })
                    }}</span>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="right">
          <ul class="right-header">
            <li v-for="item in rightHeaderNav" :key="item.nav">
              <router-link :to="item.nav">
                <span
                  :class="{ active: activePage === item.nav }"
                  @click="activePage = item.nav"
                  >{{ $t(`collect.${item.title}`) }}</span
                >
              </router-link>
            </li>
          </ul>
          <div class="right-container">
            <router-view></router-view>
          </div>
        </div>
        <div class="top hide">
          <div class="left" :class="{ userType2: userInfo.userType === 2 && userInfo.isCertification === 1 }">
            <div class="user">
              <img
                class="user_avatar"
                :src="
                  userInfo.avatar
                    | imageUrl('/static/profile_img_default.png', 60, 60)
                "
                alt
              />
              <span class="nickname">{{ userInfo.nickname }}</span>
            </div>
            <button
              class="member-focus following"
              v-if="userInfo.isFollow == 1"
              @mouseenter="toggleTitle1"
              @mouseleave="toggleTitle2"
              @click="followUser(userInfo)"
            >
              {{ $t("global.已关注") }}
            </button>
            <button
              class="member-focus add-follow"
              v-else
              @click="followUser(userInfo)"
            >
              {{ $t("global.关注") }}
            </button>
            <el-tooltip class="bg-notice" effect="light" placement="bottom">
              <span
                slot="content"
                class="people-center-share-wrap"
                @click="shareCkeck"
                >{{ $t("global.分享") }}</span
              >
              <img
                class="share"
                src="/static/v2/peopleCenter/profile_more_btn.png"
                alt
              />
            </el-tooltip>
          </div>
          <div class="right">
            <ul class="right-header">
              <li v-for="item in rightHeaderNav" :key="item.nav">
                <router-link :to="item.nav">
                  <span
                    :class="{ active: activePage === item.nav }"
                    @click="activePage = item.nav"
                    >{{ $t(`collect.${item.title}`) }}</span
                  >
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <el-dialog
        class="person-center-dialog"
        :visible.sync="visibleDialog"
        top="75px"
        :close-on-click-modal="false"
        width="1110px"
        :before-close="handleClose"
      >
        <span slot="title" class="dialog-title">
          <span
            :class="{ active: activeStep === 'follow' }"
            @click="showFollow_1"
          >
            {{ $t("global.关注") }}
            <b>{{ userInfo.followCount }}</b>
          </span>
          <span :class="{ active: activeStep === 'fans' }" @click="showFans_1">
            {{ $t("global.粉丝") }}
            <b>{{ userInfo.fansCount }}</b>
          </span>
        </span>
        <div class="person-center-person">
          <empty
            v-if="!userInfo.followCount && activeStep === 'follow'"
            url="/static/v2/peopleCenter/member_empty.png"
            :content="$t('global.还没有关注')"
            :_style="{ width: '88px', height: '88px' }"
          />
          <empty
            v-if="!userInfo.fansCount && activeStep === 'fans'"
            url="/static/v2/peopleCenter/member_empty.png"
            :content="$t('global.还没有粉丝')"
            :_style="{ width: '88px', height: '88px' }"
          />
          <ul v-if="activeStep === 'follow'">
            <li v-for="item in followList" :key="item.id">
              <member-card :item="item" />
            </li>
          </ul>
          <ul v-if="activeStep === 'fans'">
            <li v-for="item in fansList" :key="item.id">
              <member-card :item="item" />
            </li>
          </ul>
          <Loading v-if="loading" />
          <Reload v-if="loadError" @callback="loadMore" />
          <no-more
            v-if="!hasNextPage && (fansList.length || followList.length)"
          />
        </div>
      </el-dialog>
      <el-dialog
        class="person-center-share-dialog"
        :visible.sync="visibleShare"
        :close-on-click-modal="false"
        top="25vh"
        width="300px"
      >
        <span slot="title" class="person-center-share-title">{{
          $t("global.分享到其它平台")
        }}</span>
        <share :config="config"></share>
      </el-dialog>
    </section>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import Reload from "@/components/v2/match/reload";
import Loading from "@/components/v2/match/loading";
import NoMore from "@/components/v2/NoMore";
import MemberCard from "@/components/v2/peopleCenter/MemberCard";
import Empty from "@/components/v2/Empty";
import Share from "@/components/v2/Share";
import ShowImage from "@/components/v2/ShowImage";

export default {
  components: {
    MainLayout,
    Reload,
    MemberCard,
    Loading,
    Empty,
    Share,
    ShowImage,
    NoMore,
  },
  props: ["userId"],
  data() {
    return {
      liveData: null,
      showCrop: false,
      isUser: false,
      userInfo: {},
      config: {},
      isChecking: false,
      isShowUpShow: false,
      activePage: "home",
      subjectList: [],
      rightHeaderNav: [
        {
          title: "主页",
          nav: "home",
        },
        {
          title: "作品",
          nav: "video",
        },
        {
          title: "文章",
          nav: "article",
        },
        {
          title: "看单",
          nav: "collect",
        },
        {
          title: "喜欢",
          nav: "like",
        },
        {
          title: "简介",
          nav: "introduce",
        }
      ],
      pageIndex: 1,
      pageSize: 20,
      activeStep: "follow",
      loading: false,
      loadError: false,
      hasNextPage: false,
      visibleDialog: false,
      followList: [],
      fansList: [],
      visibleShare: false,
      config: {},
      showConfig: {
        img: "",
        width: "100%",
        height: "250px",
        minWidth: 1440,
        minHeight: 250,
      },
    };
  },
  created() {
    this.init();
  },
  watch: {
    $route(val) {
      if (val.query.type) {
        if (val.query.type == 1) {
          this.showFollow()
        }
        if (val.query.type == 2) {
          this.showFans()
        }
      }
    },
    userInfo(val) {
      setTimeout(() => {
        const height =
          document.querySelector(".intro") &&
          document.querySelector(".intro").offsetHeight;
        if (height > 92) {
          this.isChecking = true;
        } else {
          this.isChecking = false;
        }
      });
    },
  },
  beforeRouteUpdate(to, from, next) {
    if (
      from.name.includes("peopleCenter") &&
      to.params.userId === from.params.userId
    ) {
      // setTimeout(() => {
      //   document.querySelector("html").scrollTop = 300;
      // }, 500);
    } else if (to.params.userId !== from.params.userId) {
      setTimeout(() => {
        this.init();
      });
    }
    setTimeout(() => {
      this.changeActive();
    });
    next();
  },
  mounted() {
    window.addEventListener("scroll", this.toggleTop);
  },
  beforeRouteLeave(to, from, next) {
    this.visibleShare = false;
    window.removeEventListener("scroll", this.toggleTop, false);
    document.querySelector(".el-dialog__body") &&
      document
        .querySelector(".el-dialog__body")
        .removeEventListener("scroll", this.loadMore, false);
    next();
  },
  methods: {
    getList() {
      let params = {
        userId: this.$route.params.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get("/api/recruit/info/", { params }).then(res => {
        if (res.code == "OK") {
          if (res.data.totalRecord > 0) {
            this.rightHeaderNav = [
              {
                title: "主页",
                nav: "home",
              },
              {
                title: "作品",
                nav: "video",
              },
              {
                title: "文章",
                nav: "article",
              },
              {
                title: "看单",
                nav: "collect",
              },
              {
                title: "喜欢",
                nav: "like",
              },
              {
                title: "简介",
                nav: "introduce",
              },
              {
                title: "招聘职位",
                nav: "recruit",
              }
            ]
          }
        }
      });
    },
    getLiveData() {
      this.$http.get(`/api/bytedance/user/` + this.userId).then((res) => {
        if (res.code == "OK") {
          this.liveData = res.data;
        }
      });
    },
    gotoLiveDetail(id) {
      if (id) {
        let routeData = this.$router.resolve({
          path: "/live/liveDetail?id=" + id,
        });
        window.open(routeData.href, "_blank");
      }
    },
    init() {
      this.getLiveData();
      this.changeActive();
      this.getUserInfo();
      this.getSubjectList();
      if (this.$store.state.peopleMessage.userId) {
        this.isUser = this.userId == this.$store.state.peopleMessage.userId;
      }
      if (this.$route.query.type) {
        if (this.$route.query.type == 1) {
          this.showFollow()
        }
        if (this.$route.query.type == 2) {
          this.showFans()
        }
      }
      this.getList()
      this.buriedPoint(40,this.userId)
    },
    uploadBg() {
      this.$refs.cropUpImage.click();
    },
    cancel() {
      this.showCrop = false;
      this.$refs.cropUpImage.value = "";
    },
    changeThumb(img) {
      const url = `/api/mobile/u/info/createThumb`;
      const params = {
        userId: this.userId,
        thumb: img,
        thumbType: 0,
        type: 1,
      };
      this.$http.post(url, params).then((res) => {
        if (res.code === "OK") {
          this.$message({
            message: res.message,
            type: "success",
          });
          this.userInfo.thumb = img;
          this.cancel();
        }
      });
    },
    changeUrl(e) {
      const file = e.target.files[0];
      this.showCrop = true;
      setTimeout(() => {
        this.$refs["showImage"].getImg(file);
      }, 500);
    },
    toggleTop() {
      const leftOffsetHeight = document.querySelector(".container .left")
        .offsetHeight;
      const rightOffsetHeight = document.querySelector(".container .right")
        .offsetHeight;
      const windowHeight = document.querySelector("html").offsetHeight;
      const scrollTop = document.querySelector("html").scrollTop;
      const bodyOffsetHeight = document.querySelector(".body").offsetHeight;
      if (leftOffsetHeight < rightOffsetHeight) {
        if (
          leftOffsetHeight + 240 < windowHeight &&
          scrollTop > 130 &&
          scrollTop < bodyOffsetHeight - windowHeight - 160
        ) {
          document.querySelector(".container .left").classList.add("float");
          document.querySelector(".container .right").classList.add("float");
          document.querySelector(
            ".container .left"
          ).style.transform = `translateY(0)`;
        } else if (
          leftOffsetHeight + 370 + 20 < windowHeight + scrollTop &&
          scrollTop > 130 &&
          scrollTop < bodyOffsetHeight - windowHeight - 160
        ) {
          document.querySelector(".container .left").classList.add("float");
          document.querySelector(".container .right").classList.add("float");
          document.querySelector(
            ".container .left"
          ).style.transform = `translateY(${
            windowHeight - leftOffsetHeight - 340
          }px)`;
        }
        if (scrollTop >= 380) {
          document.querySelector(".top").classList.remove("hide");
          if (scrollTop + windowHeight >= rightOffsetHeight + 410) {
            if (leftOffsetHeight + 440 > windowHeight) {
              document
                .querySelector(".container .left")
                .classList.remove("float");
              document
                .querySelector(".container .right")
                .classList.remove("float");
              document.querySelector(
                ".container .left"
              ).style.transform = `translateY(${
                rightOffsetHeight - leftOffsetHeight
              }px)`;
            } else if (
              scrollTop + windowHeight >=
              rightOffsetHeight + 410 + 160
            ) {
              document
                .querySelector(".container .left")
                .classList.remove("float");
              document
                .querySelector(".container .right")
                .classList.remove("float");
              document.querySelector(
                ".container .left"
              ).style.transform = `translateY(${
                rightOffsetHeight - windowHeight + 250 + 160
              }px)`;
            } else if (
              scrollTop + windowHeight >= rightOffsetHeight + 410 &&
              leftOffsetHeight + 240 < bodyOffsetHeight - 160 - scrollTop
            ) {
              document
                .querySelector(".container .left")
                .classList.remove("float");
              document
                .querySelector(".container .right")
                .classList.remove("float");
              document.querySelector(
                ".container .left"
              ).style.transform = `translateY(${scrollTop - 160}px)`;
            }
          } else if (leftOffsetHeight + 370 >= windowHeight + scrollTop) {
            document
              .querySelector(".container .left")
              .classList.remove("float");
            document
              .querySelector(".container .right")
              .classList.remove("float");
            document.querySelector(
              ".container .left"
            ).style.transform = `translateY(0)`;
          }
        } else {
          if (
            scrollTop <= 130 ||
            windowHeight + scrollTop <= leftOffsetHeight + 410
          ) {
            document
              .querySelector(".container .left")
              .classList.remove("float");
            document
              .querySelector(".container .right")
              .classList.remove("float");
            document.querySelector(
              ".container .left"
            ).style.transform = `translateY(0)`;
          }
          document.querySelector(".top").classList.add("hide");
        }
      } else {
        document.querySelector(".container .left").classList.remove("float");
        document.querySelector(".container .right").classList.remove("float");
        document.querySelector(
          ".container .left"
        ).style.transform = `translateY(0)`;
        if (scrollTop >= 400) {
          document.querySelector(".top").classList.remove("hide");
        } else {
          document.querySelector(".top").classList.add("hide");
        }
      }
    },
    toggleTitle1() {
      event.target.classList.add("focus");
      document.querySelector(".following").innerHTML = this.$t(
        "global.取消关注"
      );
    },
    toggleTitle2() {
      event.target.classList.remove("focus");
      document.querySelector(".following").innerHTML = this.$t("global.已关注");
    },
    followUser(item) {
      const url = `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
        this.userId
      }`;
      this.$http.post(url).then((res) => {
        if (res.code === "OK") {
          item.isFollow = !item.isFollow;
          this.userInfo.fansCount = res.data.fansCount;
        }
      });
    },
    handleClose() {
      this.pageIndex = 1;
      document
        .querySelector(".el-dialog__body")
        .removeEventListener("scroll", this.loadMore, false);
      this.visibleDialog = false;
      this.followList = [];
      this.fansList = [];
    },
    getFollowList() {
      this.loading = true;
      const url = `/api/customer/followList/${this.userId}`;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.followList = [];
          }
          this.hasNextPage = res.data.hasNextPage;
          this.followList = [...this.followList, ...res.data.list];
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
          this.loadError = true;
        }
      });
    },
    getFansList() {
      this.loading = true;
      const url = `/api/customer/fansList/${this.userId}`;
      const params = {
        userId: this.userId,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      this.$http.get(url, { params }).then((res) => {
        this.loading = false;
        if (res.code === "OK") {
          this.loadError = false;
          if (this.pageIndex === 1) {
            this.fansList = [];
          }
          this.hasNextPage = res.data.hasNextPage;
          this.fansList = [...this.fansList, ...res.data.list];
        } else {
          if (this.pageIndex !== 1) {
            this.pageIndex--;
          }
          this.loadError = true;
        }
      });
    },
    loadMore() {
      if (document.querySelector(".person-center-person")) {
        const scrollTop = document.querySelector(".el-dialog__body").scrollTop;
        const height = document.querySelector(".el-dialog__body").offsetHeight;
        const offsetHeight = document.querySelector(".person-center-person")
          .offsetHeight;
        if (scrollTop + height > offsetHeight) {
          if (!this.loading && this.hasNextPage) {
            this.pageIndex++;
            if (this.activeStep === "follow") {
              this.getFollowList();
            } else {
              this.getFansList();
            }
          }
        }
      }
    },
    getSubjectList() {
      const url = `/api/mobile/2.0/u/getWorksIncludedList`;
      const params = {
        userId: this.userId,
        pageIndex: 1,
        pageSize: 5,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.subjectList = res.data.list;
        }
      });
    },
    changeActive() {
      const routeName = this.$route.name;
      switch (routeName) {
        case "peopleCenterHome":
          this.activePage = "home";
          break;
        case "peopleCenterVideo":
          this.activePage = "video";
          break;
        case "peopleCenterArticle":
          this.activePage = "article";
          break;
        case "peopleCenterCollect":
          this.activePage = "collect";
          break;
        case "peopleCenterLike":
          this.activePage = "like";
          break;
        case "peopleCenterIntroduce":
          this.activePage = "introduce";
          break;
        case "peopleCenterRecruit":
          this.activePage = "recruit";
          break;  
        default:
          this.activePage = "home";
          break;
      }
    },
    getUserInfo() {
      const url = `/api/mobile/u/getInfo`;
      const params = {
        userId: this.userId,
        type: 1,
      };
      this.$http.get(url, { params }).then((res) => {
        if (res.code === "OK") {
          this.userInfo = res.data;
          this.userInfo = {
            ...this.userInfo,
            thumb: res.data.thumbType === 0 ? res.data.thumb : "",
            field: (res.data.field && res.data.field.split(",")) || [],
          };
        }
      });
    },
    shareCkeck() {
      this.config = {
        share_url: location.href,
        title: this.userInfo.nickname,
        desc: "MANA 全球新媒体艺术平台",
        pics: [
          this.userInfo.avatar ||
            "http://image.manamana.net/1547206259704_manalogo.jpg",
        ],
      };
      this.visibleShare = true;
    },
    showFollow() {
      if (!this.visibleDialog) {
        this.visibleDialog = true;
        this.activeStep = "follow";
        this.pageIndex = 1;
        this.getFollowList();
        this.fansList = [];
        setTimeout(() => {
          document
            .querySelector(".el-dialog__body")
            .addEventListener("scroll", this.loadMore);
        });
      }
    },
    showFans() {
      if (!this.visibleDialog) {
        this.visibleDialog = true;
        this.activeStep = "fans";
        this.pageIndex = 1;
        this.getFansList();
        this.followList = [];
        setTimeout(() => {
          document
            .querySelector(".el-dialog__body")
            .addEventListener("scroll", this.loadMore);
        });
      }
    },
    showFollow_1() {
      if (this.activeStep !== "follow") {
        this.visibleDialog = true;
        this.activeStep = "follow";
        this.pageIndex = 1;
        this.fansList = [];
        this.getFollowList();
      }
    },
    showFans_1() {
      if (this.activeStep !== "fans") {
        this.visibleDialog = true;
        this.activeStep = "fans";
        this.pageIndex = 1;
        this.followList = [];
        this.getFansList();
      }
    },
  },
  computed: {
    language() {
      return this.$language();
    },
    peopleMessage() {
      return this.$store.state.peopleMessage
    }
  },
};
</script>

<style lang="stylus" scoped>
.people_center {
  background: #fff;
  min-height: calc(100vh - 228px);
  min-width: 1280px;

  .header {
    height: 250px;
    padding: 0;
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;

    img {
      max-width: 1440px;
      height: 250px;
      display: block;
      margin: 0 auto;
    }

    .up-input-crop {
      display: none;
    }

    .bg-notice {
      position: absolute;
      bottom: 60px;
      right: calc(50vw - 555px);
      height: 30px;
      padding: 5px 32px;
      background: rgba(10, 10, 10, 0.8);
      color: #fff;
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      border-radius: 0;
      cursor: pointer;

      &:hover {
        color: #b8b8b8;
      }
    }
  }

  .container {
    width: 1110px;
    margin: 90px auto 0;

    .top {
      display: flex;
      flex-direction: row;
      background: #fff;
      position: fixed;
      height: 60px;
      width: 100vw;
      top: 66px;
      left: 0;
      z-index: 111;
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
      transition: top 0.2s;

      // border-top: 1px solid #ebebeb;
      &.hide {
        top: -60px;
        transition: top 0.2s;
      }

      .left {
        flex: 1;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 48px;

        .user {
          position: relative;
          display: flex;
          flex-direction: row;
          max-width: 185px;
          margin-right: 30px;
          align-items: center;

          &.userType2 {
            &::before {
              content: '';
              position: absolute;
              width: 10px;
              height: 10px;
              background: url('/static/v2/match/Verified_icon_blue_20.png');
              background-size: 10px;
              z-index: 1;
              top: -50px;
              left: 175px;
            }
          }

          .user_avatar {
            width: 28px;
            height: 28px;
            border-radius: 15px;
            border: 1px solid #f5f5f5;
          }

          .nickname {
            padding-left: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }

        .member-focus {
          vertical-align: middle;
          width: 90px;
          height: 30px;
          padding: 5px 0;
          background: #2026CC;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;

          &.add-follow::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('/static/v2/channel_follow_btn_plus.png');
            background-size: 12px;
            margin-right: 3px;
            vertical-align: middle;
            margin-top: -2px;
          }

          &.following {
            background: #fff;
            border: 1px solid #b8b8b8;
            color: #b8b8b8;

            &.focus {
              color: #999;
              border-color: #999;
            }
          }
        }

        .bg-notice {
          height: 30px;
          padding: 5px 10px;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          border-radius: 0;
          cursor: pointer;

          &:hover {
            color: #b8b8b8;
          }
        }
      }

      .right {
        width: calc(50vw + 175px);
        line-height: 60px;

        .right-header {
          display: flex;
          flex-direction: row;

          li {
            padding-right: 60px;

            a {
              color: unset;

              span {
                cursor: pointer;
                display: inline-block;
                font-size: 16px;
                height: 26px;
                line-height: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;

                &.active {
                  color: #2026CC;
                  display: inline-block;

                  b {
                    color: #666;
                  }
                }

                &:hover {
                  color: #0A0A0A;
                }
              }
            }
          }
        }
      }
    }

    &>.left {
      width: 285px;
      padding-right: 90px;
      position: relative;
      display: inline-block;
      vertical-align: text-top;

      &.float {
        position: fixed;
        top: 316px;
      }

      .user_info {
        text-align: center;
        position: relative;
        padding-bottom: 40px;

        &.userType2 {
          &::before {
            content: '';
            position: absolute;
            width: 24px;
            height: 24px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 24px;
            z-index: 1;
            top: -50px;
            left: 175px;
          }
        }

        .user_avatar {
          width: 138px;
          height: 138px;
          border-radius: 50%;
          position: absolute;
          top: -160px;
          left: 73px;
          background: #f5f5f5;
          border: 2px solid rgba(245, 245, 245, 1);
        }

        .nickname {
          display: block;
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #0A0A0A;
        }

        .companyName {
          display: block;
          font-size: 14px;
          font-weight: 400;
          color: #999;
          padding-top: 10px;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          &::before {
            content: '';
            display: inline-block;
            position: relative;
            top: 2px;
            margin-right: 2px;
            width: 16px;
            height: 16px;
            background: url('/static/v2/match/Verified_icon_blue_20.png') no-repeat;
            background-size: 16px;
            z-index: 1;
          }
        }

        .focus-warp {
          padding-top: 25px;

          .member-focus {
            vertical-align: middle;
            width: 90px;
            height: 30px;
            padding: 5px 0;
            background: #2026CC;
            color: #fff;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;

            &.add-follow::before {
              content: '';
              display: inline-block;
              width: 12px;
              height: 12px;
              background: url('/static/v2/channel_follow_btn_plus.png');
              background-size: 12px;
              margin-right: 3px;
              vertical-align: middle;
              margin-top: -2px;
            }

            &.following {
              background: #fff;
              border: 1px solid #b8b8b8;
              color: #b8b8b8;

              &.focus {
                color: #999;
                border-color: #999;
              }
            }
          }

          span {
            display: inline-block;
          }

          .share {
            width: 30px;
            height: 30px;
            margin-left: 6px;
            cursor: pointer;
          }
        }

        .liveNow {
          width: 285px;
          padding-bottom: 15px;
          background: rgba(245, 245, 245, 1);
          margin-top: 20px;
          position: relative;
          cursor: pointer;

          .topLive {
            img {
              display: inline-block;
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 8px;
            }

            height: 21px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(254, 86, 48, 1);
            line-height: 21px;
            padding: 15px 0 0 20px;
            text-align: left;
            margin-bottom: 7px;
          }

          .text {
            min-height: 19px;
            font-size: 14px;
            font-family: NunitoSans-Regular, NunitoSans;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 19px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            width: 230px;
            margin-left: 20px;
            text-align: left;
            word-wrap: break-word;
            position: relative;
            padding-right: 20px;

            .rightIcon {
              position: absolute;
              width: 14px;
              height: 14px;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        .liveNotice {
          width: 285px;
          padding-bottom: 15px;
          background: rgba(245, 245, 245, 1);
          margin-top: 20px;
          position: relative;
          cursor: pointer;

          .topLive {
            img {
              display: inline-block;
              width: 20px;
              height: 20px;
              vertical-align: middle;
              margin-right: 8px;
            }

            height: 21px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(10, 10, 10, 1);
            line-height: 21px;
            padding: 15px 0 0 20px;
            text-align: left;
            margin-bottom: 7px;
          }

          .text {
            min-height: 19px;
            font-size: 14px;
            font-family: NunitoSans-Regular, NunitoSans;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 19px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            width: 230px;
            margin-left: 20px;
            text-align: left;
            word-wrap: break-word;

            span {
              margin-right: 10px;
            }

            position: relative;
            padding-right: 20px;

            .rightIcon {
              position: absolute;
              width: 14px;
              height: 14px;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
            }
          }
        }

        .signature {
          padding-top: 20px;
          font-size: 14px;
          line-height: 24px;
          color: #999;
        }

        .area-warp {
          padding-top: 22px;

          img {
            width: 10px;
            height: 13px;
          }

          .area {
            margin-right: 10px;
            color: #999;
            padding-right: 10px;
            line-height: 12px;
            border-right: 1px solid #EBEBEB;
            height: 12px;
            display: inline-block;
          }

          .follow_fans {
            height: 28px;
            display: inline-block;
            font-size: 14px;

            span {
              cursor: pointer;
              color: #666;
              line-height: 28px;
              display: inline-block;
              margin-right: 18px;

              &:last-child {
                margin-right: 0;
              }

              b {
                display: inline-block;
                color: #333;
                font-size: 18px;
                font-family: NunitoSans-SemiBold, NunitoSans;
                font-weight: 600;
                line-height: 28px;
                vertical-align: bottom;

                &:hover {
                  color: #0a0a0a;
                }
              }
            }
          }
        }

        .areaWarpEn {
          .area {
            border-right: none;
          }

          .follow_fans {
            display: block;
            margin-top: 5px;
          }
        }

        .introduce {
          position: relative;
          clear: both;
          margin-top: 25px;
          font-size: 14px;
          transition: all 3s ease;

          p {
            color: #0A0A0A;
            font-weight: 500;
            font-size: 14px;
            line-height: 24px;
            text-align: left;

            .intro {
              color: #333;
              line-height: 24px;
              word-break: break-word;
            }

            &.checking {
              max-height: 96px;
              overflow: hidden;

              span::after {
                content: '...';
                width: 120px;
                text-align: center;
                position: absolute;
                bottom: 0;
                right: 0;
                background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0) 0%, #fff 30%, #fff);
              }
            }
          }

          .showdown {
            color: #2026CC;
            position: absolute;
            cursor: pointer;
            right: 5px;
            bottom: 3px;
          }

          .showup {
            color: #2026CC;
            text-align: left;
            cursor: pointer;
            margin-top: 5px;
            float: right;
          }
        }

        .field {
          padding-top: 30px;
          text-align: left;
          overflow: hidden;

          span {
            float: left;
            display: block;
            max-width: 100%;
            background: #EBEBEB;
            padding: 0 8px;
            color: #333;
            line-height: 26px;
            margin: 0 8px 8px 0;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
        }
      }

      .video_subject {
        padding-top: 30px;

        h4 {
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #666;
        }

        ul {
          padding-bottom: 40px;

          li {
            margin-top: 30px;

            a {
              display: flex;
              flex-direction: row;

              .subject-left {
                height: 65px;
                width: 65px;
                margin-right: 10px;
              }

              .subject-right {
                flex: 1;

                h5 {
                  font-size: 15px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  line-height: 19px;
                  height: 38px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                  word-break: break-word;
                  color: #333333;

                  &:hover {
                    color: #0a0a0a;
                  }
                }

                span {
                  font-family: NunitoSans-Regular, NunitoSans;
                  color: #999;
                  padding-top: 9px;
                  display: block;
                }
              }
            }
          }
        }
      }
    }

    &>.right {
      width: 730px;
      max-width: 730px;
      display: inline-block;
      vertical-align: text-top;

      &.float {
        margin-left: 379px;
      }

      .right-header {
        display: flex;
        flex-direction: row;
        height: 27px;
        border-bottom: 1px solid #EBEBEB;

        li {
          padding-right: 60px;

          a {
            color: unset;

            span {
              cursor: pointer;
              display: inline-block;
              font-size: 16px;
              height: 26px;
              line-height: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;

              &.active {
                color: #2026CC;
                display: inline-block;
                border-bottom: 2px solid #2026CC;
              }

              &:hover {
                color: #0A0A0A;
                border-bottom: 2px solid #0A0A0A;
              }
            }

            &:hover span.active {
              color: #2026CC;
              border-bottom: 2px solid #2026CC;
            }
          }
        }
      }

      .right-container {
      }
    }
  }

  .person-center-person {
    padding: 0 45px 140px;

    ul {
      padding-bottom: 20px;

      li {
        border-bottom: 1px solid #EBEBEB;
        padding: 20px 0 30px;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
</style>
<style lang="stylus">
.person-center-dialog {
  .el-dialog {
    height: calc(100vh - 150px);
    overflow: hidden;
    margin-bottom: 0;
  }

  .el-dialog__header {
    padding: 20px;
    border-bottom: 1px solid #E0E0E0;

    .dialog-title {
      padding-left: 45px;

      span {
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #b8b8b8;
        display: inline-block;
        margin-right: 35px;
        cursor: pointer;

        &.active {
          color: #0A0A0A;

          b {
            color: #666;
          }
        }

        b {
          color: #B8B8B8;
          font-family: NunitoSans-SemiBold, NunitoSans;
          font-size: 14px;
        }
      }
    }
  }

  .el-dialog__body {
    height: calc(95vh - 122px);
    overflow: scroll;
  }
}

.person-center-share-dialog {
  .el-dialog__header {
    border-bottom: 1px solid #EBEBEB;

    .person-center-share-title {
      padding: 0 24px;
      font-size: 16px;
    }
  }

  .el-dialog__body {
    padding: 30px 45px;

    .share-list {
    }
  }
}

.el-tooltip__popper {
  &.is-dark {
    background: rgba(255, 255, 255, 0.8);
    border-radius: 0;
    padding: 7px 10px;

    div {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }

    .popper__arrow {
      border: none;
    }

    .popper__arrow::after {
      border-bottom-color: rgba(255, 255, 255, 0.8) !important;
    }
  }

  &.is-light {
    background: #fff;
    padding: 7px 0;
    border: none;
    box-shadow: 0px 0px 6px 0px rgba(10, 10, 10, 0.1);

    div {
      font-size: 12px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #666666;
    }

    .popper__arrow {
      border: none;
    }

    .people-center-share-wrap {
      width: 100px;
      height: 34px;
      display: inline-block;
      line-height: 34px;
      padding: 6px 0;
      text-align: center;
      cursor: pointer;
      font-size: 14px;

      &:hover {
        background: #F5F5F5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/peopleCenter/PeopleCenter.vue